import React, { useEffect, useRef } from "react";
import { GoogleMap, LoadScript } from "@react-google-maps/api";

const MapView = () => {
  const mapRef = useRef(null);

  const mapContainerStyle = {
    width: "100%",
    height: "500px",
    borderRadius: "12px",
    overflow: "hidden",
  };

  const center = { lat: 28.538336, lng: -81.379234 }; // Orlando
  const locations = [
    { lat: 27.9506, lng: -82.4572, price: "$3544" },
    { lat: 26.6406, lng: -81.8723, price: "$2999" },
  ];

  const handleMapLoad = (map) => {
    mapRef.current = map;

    // Wait for the new AdvancedMarkerElement class
    if (window.google?.maps?.marker?.AdvancedMarkerElement) {
      locations.forEach((loc) => {
        const label = document.createElement("div");
        label.style.background = "#f59e0b";
        label.style.color = "#fff";
        label.style.padding = "4px 8px";
        label.style.borderRadius = "6px";
        label.style.fontSize = "12px";
        label.style.fontWeight = "bold";
        label.textContent = loc.price;

        new window.google.maps.Marker({
          position: loc,
          map,
          label: {
            text: loc.price,
            color: "#fff",
            fontWeight: "bold",
            fontSize: "12px",
          },
          icon: {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 16,
            fillColor: "#f59e0b",
            fillOpacity: 1,
            strokeColor: "#fff",
            strokeWeight: 2,
          },
        });
      });
    }
  };

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyCEW1Wc11SUHoF3sgsxEq0M1XgOqSelP5M"
      libraries={["marker"]} // ✅ Required for AdvancedMarkerElement
    >
      <GoogleMap
        onLoad={handleMapLoad}
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={6}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
        }}
      />
    </LoadScript>
  );
};

export default MapView;
